<template>
  <div style="max-width: 600px;">

    <div class="panel">
      <b-button v-b-modal.help-modal>Help</b-button>

      <b-button
        v-if="mayEditPlayerData && isDataLoaded"
        :disabled="!isCopyCreationEnabled"
        @click="createCopy"
      >
        Create copy
      </b-button>
    </div>

    <player-resource-log-items
      v-if="isDataLoaded"
      :items="resourceLog"
    />

    <loading-indicator
      v-if="isLoading"
    />

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          В журнале ресурсов сообщение хранится 7 дней.
          (Сообщения, которые старше 7-и дней, автоматически удаляются.)
        </p>
        <p>
          Чтобы сохранить состояние журнала ресурсов, можно создать копию журнала ресурсов.
          Копия хранится постоянно.
          Для создания копии журнала ресурсов нажмите кнопку Create copy (Создать копию).
        </p>
        <p>
          Для просмотра копий журнала ресурсов выберите в&nbsp;боковом меню слева пункт
          <router-link
           :to="{name: 'player_resource_log_copies', params: {playerId: playerId}}"
          >
            Resource log copies
          </router-link>
          (Копии журнала ресурсов).
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerResourceLogItems from './PlayerResourceLogItems.vue';
import { mayEditPlayerData as utilMayEditPlayerData } from '../util';
import { getProtoAlias } from '../util';

export default {
  name: 'PlayerResourceLog',

  components: {
    LoadingIndicator,
    PlayerResourceLogItems,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      actor: auth.getViewer(),
      isLoading: false,
      resourceLog: null,
    };
  },

  computed: {
    isDataLoaded() {
      return this.resourceLog !== null;
    },

    message() {
      if(this.resourceLog !== null && this.resourceLog.length === 0) {
        return 'Resource log is empty.';
      }
      return null;
    },

    mayEditPlayerData() {
      return utilMayEditPlayerData(this.actor.role);
    },

    isCopyCreationEnabled() {
      return this.resourceLog !== null && this.resourceLog.length > 0;
    },
  },

  created() {
    this.isLoading = true;
    HTTP.get('/player/' + this.playerId + '/resource_log')
    .then(response => {
      this.resourceLog = [];
      for(var i = 0; i < response.data.data.length; ++i) {
        const item = response.data.data[i];
        item.productAlias = getProtoAlias(item.proto_id);
        this.resourceLog.push(item);
      }
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    createCopy() {
      notifier.deleteSenderNotifications(this);

      const url = `/player/${this.playerId}/resource_log_copy/create`;
      HTTP.post(url)
      .then(response => {
        const copyId = response.data.data;
        notifier.showSuccessAfterTransition('Copy created.');
        this.$router.push({name: 'player_resource_log_copy', params: {playerId: this.playerId, copyId: copyId}});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
  .panel {
    margin-bottom: 1em;
  }

  .help p {
    margin-bottom: 1em;
  }
</style>
